var map = {
	"./Christmas_title.png": "8+iQ",
	"./Spotlight.png": "Hpyu",
	"./VIP_dark@2x.png": "j+uX",
	"./activityEndIcon.png": "oHOP",
	"./activityEndIcon_moon.png": "3Rv5",
	"./activityFailIcon.png": "wAuy",
	"./activityFailIcon_moon.png": "lH7/",
	"./activitySuccessIcon.png": "M+Mh",
	"./activitySuccessIcon_moon.png": "pbF1",
	"./activityWaitIcon.png": "zB2g",
	"./activityWaitIcon_moon.png": "SLBn",
	"./anniversary/VIP_dark@2x.png": "gxPQ",
	"./anniversary/bg_1@2x.png": "A9/c",
	"./anniversary/bg_2@2x.png": "WJsD",
	"./anniversary/box@2x.png": "haSR",
	"./anniversary/coupon_dark@2x.png": "F5RM",
	"./anniversary/coupon_light@2x.png": "yAg9",
	"./anniversary/h5Bg.png": "iuIb",
	"./anniversary/line @2x.png": "J8fM",
	"./anniversary/pumpkin_dark@2x.png": "K2WS",
	"./anniversary/pumpkin_light@2x.png": "n+Ic",
	"./anniversary/title@3x.png": "gy66",
	"./anniversary/tree@3x.png": "vBqa",
	"./anniversary/vip_select@2x.png": "Bcqo",
	"./anniversary/yuanMoney.png": "mTaJ",
	"./apiKeyBg_day.png": "jKxU",
	"./apiKeyBg_moon.png": "2fYL",
	"./apikey/apiKeyBg_day.png": "p7J0",
	"./apikey/apiKeyBg_moon.png": "kED/",
	"./artEmpty.png": "Ga/+",
	"./banner@2x.png": "XPr2",
	"./bg_1@2x.png": "GUXX",
	"./bg_2@2x.png": "Si/4",
	"./blackIcon.png": "RJ8f",
	"./bottomBg.png": "B9FT",
	"./bottomBg_moon.png": "D5WT",
	"./box@2x.png": "u7hH",
	"./chGuys.png": "7u5N",
	"./channel.png": "bvql",
	"./close.png": "/TeD",
	"./contractPoint/arrow-day.png": "8Yy+",
	"./contractPoint/arrow-day1.png": "X9lH",
	"./contractPoint/arrow-moon.png": "C4dd",
	"./contractPoint/arrow-moon1.png": "AwQR",
	"./contractPoint/bg_header.png": "pK/X",
	"./contractPoint/bg_points_details_1.png": "L+F8",
	"./contractPoint/bg_points_details_2.png": "w3tp",
	"./contractPoint/goRightH5.png": "qBOq",
	"./contractPoint/icon_get_btn_1.png": "g4D8",
	"./contractPoint/icon_get_points.png": "C1A/",
	"./contractPoint/icon_sign_header.png": "iOoY",
	"./contractPoint/icon_sign_header2.png": "bEYi",
	"./contractPoint/icon_sign_list_1.png": "I/uj",
	"./contractPoint/icon_sign_list_2.png": "CR/H",
	"./contractPoint/icon_sign_list_3.png": "Zyub",
	"./contractPoint/noActBg_h5.png": "dVeH",
	"./contractPoint/pointIcon1-sunlight.png": "gv9V",
	"./contractPoint/pointIcon1.png": "O8d1",
	"./contractPoint/pointIcon2.png": "ksw1",
	"./contractPoint/pointIcon3.png": "URTl",
	"./contractPoint/rankIcon.png": "hd1u",
	"./contractPoint/sevenFinishBg-fa.png": "2Qpr",
	"./contractPoint/sevenFinishBg.png": "5yQ9",
	"./contractPoint/tohook.png": "Iru3",
	"./contractPoint/wheelBg.png": "AgTL",
	"./contractPoint/wheelBgtwo.png": "F3xK",
	"./contractPoint/wheelBgtwo_new.png": "kGoy",
	"./contractPoint/wheelBtn.png": "lEkp",
	"./contractPoint/wheelFloor.png": "XhIP",
	"./contractPoint/wheelIcon.png": "CnCQ",
	"./contractTrade/tree@3x.png": "Viq6",
	"./contractTrade/yuanMoney.png": "sbIc",
	"./coupon_dark@2x.png": "CeNT",
	"./coupon_light@2x.png": "M80c",
	"./currency.png": "NFIp",
	"./dmtAorrow.png": "9TRi",
	"./fiat.png": "zh9N",
	"./freeImg.png": "Glv+",
	"./freeZoneShareBg.png": "Qmwj",
	"./freeZoneShareBgFa.png": "wB8Z",
	"./goFreeRight.png": "i0Rt",
	"./goRight.png": "PSvB",
	"./goleft.png": "mlGs",
	"./h5Bg.png": "88AQ",
	"./icon_college_night@2x(1).png": "jicl",
	"./icon_college_night@2x.png": "kyVp",
	"./icon_copy@2x(1).png": "6nyU",
	"./icon_copy@2x.png": "CpLo",
	"./image_date@2x.png": "ynUy",
	"./image_news@2x.png": "xku/",
	"./image_study@2x.png": "Ifur",
	"./image_video@2x.png": "RHP7",
	"./line @2x.png": "kPt8",
	"./mask.png": "mRby",
	"./newImg/app-btn-bg.png": "JGe1",
	"./newImg/app-thumb-desktop.png": "T9qB",
	"./newImg/app-thumb-mobile.png": "rKY8",
	"./newImg/intro-thumb-1-dot.png": "rGkM",
	"./newImg/intro-thumb-1.png": "0c2N",
	"./newImg/intro-thumb-bg.png": "gcA+",
	"./newImg/join-us.png": "x/E+",
	"./newImg/join-usV3.png": "2iE+",
	"./newImg/logo.png": "60P/",
	"./newImg/partner-1.png": "WYxk",
	"./newImg/partner-2.png": "g+vb",
	"./newImg/partner-3.png": "sC+X",
	"./newImg/partner-4.png": "gF22",
	"./newImg/qrcode-box.png": "kcMN",
	"./newImg/story-1.png": "W3yO",
	"./newImg/story-2.png": "Tydo",
	"./newImg/story-3.png": "+0/s",
	"./newImg/story-4.png": "t8jY",
	"./newImg/story-5.png": "VUU2",
	"./newImg/story-6.png": "gVLz",
	"./newImg/story-7.png": "lHX3",
	"./newLogo.png": "JN3v",
	"./newLogoV3.png": "jn0D",
	"./pay.png": "321P",
	"./pumpkin_dark@2x.png": "ChhP",
	"./pumpkin_light@2x.png": "yEQk",
	"./rankBg.png": "YY/c",
	"./rankBgFa.png": "imi4",
	"./rankOneIcon.png": "yk7X",
	"./rankOtherIcon.png": "Ats9",
	"./rankThreeIcon.png": "4Zu8",
	"./rankTwoIcon.png": "BHjB",
	"./treeBg.png": "fYuj",
	"./uscIcon.png": "7ppX",
	"./vip_select@2x.png": "4oJu",
	"./xuanZhong111.png": "WEQa",
	"./yuanMoney.png": "s+HU",
	"./yuanyuanCH.png": "3Su7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 0